'use strict';

function buildPublishProductRequestBody(product, accessToken, manufacturingTimeDays) {
  const body = { product, accessToken };
  if (manufacturingTimeDays !== undefined) {
    body.manufacturingTimeDays = manufacturingTimeDays;
  }
  return body;
}

async function postPublishProductRequest({ apiBaseUrl, product, accessToken, manufacturingTimeDays, fetchImpl = globalThis.fetch }) {
  return fetchImpl(`${apiBaseUrl}/api/mercadolibre/publish-product`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(buildPublishProductRequestBody(product, accessToken, manufacturingTimeDays))
  });
}

module.exports = {
  buildPublishProductRequestBody,
  postPublishProductRequest
};